import React from 'react';
const index: React.FC = () => {
  return <>Test</>;
};

export default index;
